export class LocalStorageManager {

	static set(key: string, value: string) {
		localStorage.setItem(key, value);
	}

	static get(key: string): string {
		return localStorage.getItem(key) as string;
	}

	static remove(key: string): void {
		localStorage.removeItem(key);
	}
}